import type { Song } from "../types";

/** Mary Had a Little Lamb (traditional, public domain). */
export const maryHadALittleLamb: Song = {
  id: "mary-had-a-little-lamb",
  title: "Mary Had a Little Lamb",
  bpm: 100,
  instrument: "piano",
  notes: [
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 2 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 4 },
  ],
};
